// @ts-nocheck
import Autocomplete from "@mui/material/Autocomplete";
import { forwardRef, useRef, useState, useEffect, useMemo } from "react";
import axiosWrapper from "../../services/axiosWrapper";

const AutoComplete = forwardRef((props: any, ref: any) => {
  const btnRef = useRef(ref || null);
  const [optionsState, setOptionsState] = useState<any>([]);
  const [isLoading, setIsLoading] = useState<boolean>(false);

  const {
    sx = {},
    remoteDataSource,
    query,
    options,
    beforeDataBound,
    width,
    getOptionLabel,
    renderOption,
    valueField,
    value,
    defaultValue,
    ...otherProps
  } = props;

  useEffect(() => {
    try {
      if (Array.isArray(options)) {
        setOptionsState(options);
      } else if (!remoteDataSource && !query) {
        throw new Error("options should be an array or use remote data source");
      }
    } catch (e) {
      console.log(e);
    }
  }, [options]);

  const valueMemo = useMemo(() => {
    if (valueField && typeof value === "string") {
      return optionsState.find((o) => o?.[valueField] === value) ?? null;
    }
    return value;
  }, [value, valueField, optionsState]);

  const defaultValueMemo = useMemo(() => {
    if (valueField && typeof defaultValue === "string") {
      return optionsState.find((o) => o?.[valueField] === defaultValue) ?? null;
    }
    return defaultValue;
  }, [defaultValue, valueField, optionsState]);

  const fetchOptions = async (queryParam = query) => {
    if (!queryParam || !remoteDataSource) return;
    setIsLoading(true);
    const response = await axiosWrapper.post(remoteDataSource, { value: queryParam });
    const optionsData = beforeDataBound ? beforeDataBound(response, queryParam) : response.data.result;
    setOptionsState(optionsData);
    setIsLoading(false);
  };

  useEffect(() => {
    fetchOptions();
  }, [query]);

  const defaultRenderOption = (props: any, option: any) => {
    let content;
    if (renderOption) {
      content = renderOption(props, option);
    } else if (getOptionLabel) {
      content = getOptionLabel(option);
    } else {
      content = option.label;
    }

    return (
      <li
        {...props}
        style={{
          borderTop: "1px solid #ECF3FE",
          height: "48px",
          padding: "0 16px",
          whiteSpace: "nowrap",
          overflow: "hidden",
          lineHeight: "48px",
          display: "block",
          textOverflow: "ellipsis",
          transition: "background-color 300ms ease-in-out",
        }}
      >
        {content}
      </li>
    );
  };

  const isControlled = value !== undefined;

  return (
    <Autocomplete
      ref={btnRef}
      sx={{
        width: width || "auto",
        "& .MuiInputBase-root": { padding: "2px 6px" },
        ...sx,
      }}
      slotProps={{ listbox: { sx: { padding: 0 } } }}
      {...otherProps}
      {...(isControlled ? { value: valueMemo ?? null } : { defaultValue: defaultValueMemo })}
      loading={isLoading}
      options={optionsState}
      getOptionLabel={getOptionLabel}
      renderOption={defaultRenderOption}
    >
      {props.children}
    </Autocomplete>
  );
});

AutoComplete.displayName = "AutoComplete";

export default AutoComplete;
